"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelizeStyle = void 0;
var camelize_1 = require("./camelize");
var msPattern = /^-ms-/;
function camelizeStyle(s) {
  return camelize_1.camelize(s.replace(msPattern, 'ms-'));
}
exports.camelizeStyle = camelizeStyle;